import { render, staticRenderFns } from "./ModalFeedbackAfterImport.vue?vue&type=template&id=e81c7c22&"
import script from "./ModalFeedbackAfterImport.vue?vue&type=script&lang=js&"
export * from "./ModalFeedbackAfterImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports